import React from 'react'

const Game: React.FC = () => {
    return (
        <>
            <div id="content">
                <div id="canvas-container"></div>
                <div id="gpts"></div>
            </div>
        </>
    )
}

export default Game
